<template>
  <footer class="footer_wrap" v-if="pageType != 'about'">
    <div class="footer_container">
      <div class="footer_top" :class="footerTopClass" ref="footerTopRef">
        <div class="footer_top_title">{{ footerTopTitle }}</div>
        <div class="footer_top_info">{{ footerTopInfo }}</div>
      </div>
      <!-- 底部版权信息 -->
      <div class="footer_bottom" v-show="showFooterBottom">
        <div class="copyright">
          <p>©2025中碳普惠云科技有限公司版权所有</p>
        </div>
        <div class="footer_legal">
          <p>customerservice@carbonneutrality-group.com丨<a href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank">沪公网安备31010102008019</a> 丨 ‍<a href="https://beian.miit.gov.cn" target="_blank">沪ICP备2024080823号-1</a></p>
        </div>
      </div>
    </div>
  </footer>
  <footer class="footer_wrap_about" v-else>
    <div class="footer_container">
      <div>
        <div class="title">关于我们</div>
        <div>customerservice@carbonneutrality-group.com</div>
        <!-- <div>021-60900007</div> -->
        <div><a href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank">沪公网安备31010102008019</a> 丨 ‍<a href="https://beian.miit.gov.cn" target="_blank">沪ICP备2024080823号-1</a></div>
        <div>©2025中碳普惠云科技有限公司版权所有</div>
      </div>
      <img class="footer_container_img" src="@/assets/img/home/about_logo.png"/>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    pageType: {
      type: String,
      default: 'home'
    }
  },
  computed: {
    footerTopClass() {
      return `footer_top_${this.pageType}`;
    },
    footerTopInfo() {
      if (this.pageType === 'home') {
        return 'We Redefine the Path to Carbon Neutrality with AI';
      } else if (this.pageType === 'carbon') {
        return 'Innovative industrial civilization under climate change';
      } else if (this.pageType === 'about') {
        return 'We Redefine the Path to Carbon Neutrality with AI';
      } else if (this.pageType === 'pioneer') {
        return 'The power of communities amidst the climate crisis';
      } else if (this.pageType === 'production') {
        return 'We Redefine the Path to Carbon Neutrality with AI';
      } else if (this.pageType === 'server') {
        return 'We Redefine the Path to Carbon Neutrality with AI';
      } else {
        return 'We Redefine the Path to Carbon Neutrality with AI';
      }
    },
    footerTopTitle() {
      if (this.pageType === 'home') {
        return '我们用AI重新定义碳中和之路';
      } else if (this.pageType === 'carbon') {
        return '气候变化下的创新产业文明';
      } else if (this.pageType === 'pioneer') {
        return '气候危机下的社区力量';
      } else if (this.pageType === 'production') {
        return '我们用AI重新定义碳中和之路';
      } else if (this.pageType === 'server') {
        return 'We Redefine the Path to Carbon Neutrality with AI';
      }
    }
  },
   data() {
    return {
      showFooterBottom: true,
      hasScrolled: false
    }
  },
  mounted() {
    // this.initObserver();
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    initObserver() {
      if (this.$refs.footerTopRef) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              setTimeout(() => {
                this.showFooterBottom = true;
              }, 1000);
            }
          });
        }, {
          threshold: 0.1,
          rootMargin: '0px 0px -50px 0px'
        });
        
        this.observer.observe(this.$refs.footerTopRef);
      } else {
        setTimeout(() => {
          this.showFooterBottom = true;
        }, 1000);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.footer_wrap {
  width: 100%;

  .footer_container{
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #000;

    .footer_top{
        width: 100%;
        height: calc(100vh * 195 / 1080);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .footer_top_title{
            font-family: Inter;
            font-weight: 700;
            font-size: 52px;
            color: #fff;
            letter-spacing: 10px;
            line-height: 52px;
        }

        .footer_top_info{
            font-family: Inclusive Sans;
            font-weight: 400;
            font-size: 28px;
            line-height: 28px;
            letter-spacing: 7px;
            color: #fff;
        }
    }

    // 首页背景色
    .footer_top_home {
        background: linear-gradient(360deg, #8EFFD8 0%, #66BCFD 100%);
    }

    // 双碳页面背景色
    .footer_top_carbon {
        background: linear-gradient(360deg, rgba(24, 255, 226, 0.9) 0%, rgba(36, 199, 205, 0.9) 100%);
    }

    // 先锋页面背景色
    .footer_top_pioneer {
        background: linear-gradient(360deg, rgba(45, 254, 228, 0.8) 0%, rgba(58, 206, 211, 0.8) 100%);
    }

    // 生产页面背景色
    .footer_top_production {
        background: linear-gradient(360deg, rgba(68, 255, 176, 0.9) 0%, rgba(51, 214, 169, 0.9) 100%);
    }

    // 服务页面背景色
    .footer_top_server {
        background: linear-gradient(360deg, #EF476F 0%, #FFD166 100%);
    }

    // 默认背景色（当pageType不匹配时）
    .footer_top_default {
        background: linear-gradient(360deg, #66FBBD 0%, #66BCFD 100%);
    }

    .footer_bottom{
      width: 100%;
      height: calc(100vh * 75 / 1080);
      font-size: 16px;
      background: #fff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      a{
        color: #000;
        text-decoration: none;
      }
    }
  }
}

.footer_wrap_about{
  position: absolute;
  left: 0;
  top: calc(100vh * 1822 / 1080);
  width: 100%;
  height: calc(100vh * 270 / 1080);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: linear-gradient(360deg, #64C5FF 0%, #117FDB 100%);

  .footer_container{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: calc(100vw - (calc(100vw * 585 / 1920)));
    color:#fff;
    font-size: 24px;
    font-weight: 400;
    line-height: 28px;

    a{
      color: #fff!important;
      text-decoration: none;
    }

    .title{
      font-size: 36px;
      font-weight: 700;
      line-height: 36px;
    }

    .footer_container_img{
      width: 187px;
      height: 180px;
    }
  }
}
</style>